// get all saved ideas
export const createGetSavedIdeasRequest = (page,per_page) => {
  return {
    url: "/post_ideas",
    method: "GET",
    params: {
      page,
      per_page
    }
  };
};

// get a single saved idea by id
export const createGetSingleSavedIdeaRequest = (id) => {
  return {
    url: "/post_ideas/" + id,
    method: "GET",
  };
};

// save a new idea
export const createSaveNewIdeaRequest = (content) => {
  return {
    url: "/post_ideas",
    method: "POST",
    data: {
      content,
    },
  };
};

// update a saved idea
export const createUpdateSaveIdeaRequest = (content) => {
  return {
    url: "/post_ideas",
    method: "PUT",
    data: {
      content: content,
    },
  };
};

//delete saved idea
export const createDeleteSavedIdeaRequest = (id) => {
  return {
    url: "/post_ideas/" + id,
    method: "DELETE",
  };
};
